import { render, staticRenderFns } from "./global-settings.vue?vue&type=template&id=2a1dc046&scoped=true"
import script from "./global-settings.vue?vue&type=script&lang=js"
export * from "./global-settings.vue?vue&type=script&lang=js"
import style0 from "./global-settings.vue?vue&type=style&index=0&id=2a1dc046&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1dc046",
  null
  
)

export default component.exports